<template>
  <div class="wameed-dashboard-page-content">
    <page-header
        :title="$t('products.title')"
        :btn-title="$t('products.new_btn')"
        :route-name="'products-create'"
    />

    <div>
      <filter-header
          :content="filterContent"
          @applyFilter="applyFilter"
          @resetFilter="resetFilter"
          @orderApplicants="orderData"

          :searchPlaceholder="$t('common.search') + ' ...'"
          :btnTitle="$t('common.filter_data')"
          :menuTitle="$t('common.order_by') + ' : '"
          :subTitle="'asdf'"
          :orderByItems=" [
        {
          name: this.$i18n.t('common.newest'),
          id: 'desc',
        },
        {
          name: this.$i18n.t('common.older'),
          id: 'asc',
        },
        {
          name: this.$i18n.t('common.alphabetical'),
          id: 'name',
        },
      ]"
      />
    </div>
    <section
        class="
        wameed-dashboard-page-content_body
        d-flex
        flex-column
        justify-content-between
        overflow-hidden
      ">
      <div class="d-flex flex-wrap flex-1 ">
        <b-col lg="12" md="12" class="px-0">

          <div class="w-table">
            <w-tables
                :noDataTitle="$t('table.no_data_title')"
                :noDataSubtitle="$t('table.no_data_subtitle')"
                v-if="getData"
                :per-page="filterData.per_page"
                :items="getData"
                :fields="tableFields"

                :custimized-items="[
                { name: 'name' },
                { name: 'price' },
                { name: 'addons' },
                { name: 'types' },
                { name: 'sizes' },
                { name: 'publish' },
                { name: 'action' },
              ]"
            >

              <template slot="name" slot-scope="{ data }">
                <name-tile
                    :name="data.item.name"
                    :image="data.item.image"
                />
              </template>


              <template slot="sizes" slot-scope="{ data }">
                <check-value :value="data.item.sizes"/>
              </template>


              <template slot="price" slot-scope="{ data }">
                <check-price
                    :price="data.item.price"
                    :dis-price="data.item.dis_price"
                />
              </template>


              <template slot="addons" slot-scope="{ data }">
                <check-value :value="data.item.addons"/>
              </template>

              <template slot="types" slot-scope="{ data }">
                <check-value :value="data.item.types"/>
              </template>


              <template slot="publish" slot-scope="{ data }">
                <wameed-switch
                    :checked="data.item.publish ===1"
                    @onChange="()=>onChange(data.item)"/>
              </template>

              <template slot="action" slot-scope="{ data }">
                <b-dropdown
                    variant="background"
                    class="table-option"
                    toggle-class="text-decoration-none rounded-10 px-2 py-2 "
                    menu-class="rounded-8"
                    no-caret
                    dropleft
                >
                  <template v-slot:button-content>
                    <vertical-dots-icon/>
                  </template>

                  <b-dropdown-item
                      :to="goToUpdate(data.item.id)"
                  >
                    <span class="text-regular-14 text-font-secondary">

                      <edit-icon class="mx-2"/>
                      {{ $t('btn.edit') }}
                    </span>
                  </b-dropdown-item>

                  <b-dropdown-item
                      @click="deleteModal = true; currentItemData = data.item">
                    <span class="text-regular-14  text-danger">
                      <trash-icon class="mx-2 "/>
                      {{ $t('btn.delete') }}
                    </span>
                  </b-dropdown-item>

                </b-dropdown>
              </template>
            </w-tables>
          </div>

        </b-col>

        <b-col lg="12" md="12" class="px-0">
          <wameed-pagination
              v-if="getTotal"
              v-model="filterData.page"
              :page="filterData.page"
              :total-items="getTotal.totalItems"
              :per_page="filterData.per_page"
              @changePage="changePage"
              @changeCurrentPage="changeCurrentPage"
          />
        </b-col>

      </div>

    </section>


    <wameed-feedback-modal
        variant="danger"
        iconName="trash-icon"
        :visible="deleteModal"
        @close="deleteModal = false"
        @onClick="deleteAction"
        :title="$t('products.modal.delete')"
        :subTitle="$t('products.modal.delete_desc')"
        :btnTitle="$t('btn.delete')"
    />
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import PageHeader from '@/components/wameed/WameedPageHeader.vue';
import FilterHeader from '@/components/wameed/WameedFilterHeader.vue';
import {
  WameedPagination,
  WameedSwitch,
  WameedTables as WTables,
  WameedFeedbackModal
} from 'wameed-ui/dist/wameed-ui.esm'
import CheckValue from "@/views/pages/products/components/checkValue";
import CheckPrice from "@/views/pages/products/components/checkPrice";
import NameTile from "@/components/nameTile.table";

export default {
  components: {
    NameTile,
    CheckPrice,
    CheckValue,
    WameedFeedbackModal,
    PageHeader,
    FilterHeader,
    WameedPagination,
    WameedSwitch,
    WTables,
  },
  data() {
    return {
      showModal: false,
      deleteModal: false,
      currentItemData: null,
      filterData: {
        status: '',
        page: 1,
        per_page: 20,
        order_by: 'desc',
        search: '',
      },
      filterContent: [
        {
          title: this.$i18n.t('common.status'),
          key: 'status',
          id: 'id',
          name: 'title',
          type: 'text',
          selectedData: [],
          translate: true,
          data: [
            {
              id: 'active',
              title: this.$i18n.t('common.exist'),
            },
            {
              id: 'not_active',
              title: this.$i18n.t('common.not_exist'),
            },
          ],
        },
        {
          title: this.$i18n.t('filters.addons'),
          key: 'addons',
          id: 'id',
          name: 'title',
          type: 'text',
          selectedData: [],
          translate: true,
          data: [
            {
              id: 'exist',
              title: this.$i18n.t('common.exist'),
            },
            {
              id: 'not_exist',
              title: this.$i18n.t('common.not_exist'),
            },
          ],
        },
        {
          title: this.$i18n.t('filters.types'),
          key: 'types',
          id: 'id',
          type: 'text',
          name: 'title',
          selectedData: [],
          translate: true,
          data: [
            {
              id: 'exist',
              title: this.$i18n.t('common.exist'),
            },
            {
              id: 'not_exist',
              title: this.$i18n.t('common.not_exist'),
            },
          ],
        },
      ],
      tableFields: [
        {
          key: "index",
          label: "#",
          sortable: true,
        },

        {
          key: 'name',
          label: this.$i18n.t('products.table.name'),
          sortable: false,
          tdClass: 'w-2/8'
        },
        {
          key: 'category',
          label: this.$i18n.t('products.table.category'),
          sortable: false,
          tdClass: 'w-1/8'
        },

        {
          key: 'sizes',
          label: this.$i18n.t('products.table.sizes'),
          sortable: false,
          tdClass: 'w-1/8'
        },

        {
          key: 'price',
          label: this.$i18n.t('table.price'),
          sortable: false,
          tdClass: 'w-1/8'
        },

        {
          key: 'types',
          label: this.$i18n.t('products.table.types'),
          sortable: false,
          tdClass: 'w-1/8'
        },

        {
          key: 'addons',
          label: this.$i18n.t('products.table.addons'),
          sortable: false,
          tdClass: 'w-1/8'
        },

        {
          key: 'publish',
          label: this.$i18n.t('table.availability'),
          sortable: false,
          tdClass: 'w-1/8'
        },
        {
          key: 'action',
          label: this.$i18n.t('table.options'),
          tdClass: 'w-1/8'
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      getData: 'vendor/products/getData',
      getTotal: 'vendor/products/getTotal',
    }),
  },
  created() {
    this.loadData();
  },
  methods: {
    ...mapActions({
      _getData: 'vendor/products/get',
      _deleteData: 'vendor/products/delete',
    }),

    onChange(item) {
      let publish = 1;
      if (item.publish === 1) {
        publish = 0;
      }
      this.$store.dispatch('vendor/products/toggle', {id: item.id, publish: publish})
    },

    changeCurrentPage(item) {
      this.filterData = {
        ...this.filterData,
        per_page: item.id,
      };
      this.loadData();
    },

    changePage(event) {
      this.filterData = {
        ...this.filterData,
        page: event,
      };
      this.loadData();
    },

    loadData() {
      this._getData(this.filterData);
    },

    deleteAction() {
      this.deleteModal = false
      this._deleteData(this.currentItemData.id);
    },
    goToUpdate(id) {
     return {
        name: 'products-update',
        params: {lang: this.$i18n.locale, id},
      };
    },

    applyFilter() {
      this.filterContent.forEach(item => {
        this.filterData[item.key] = item.selectedData.toString();
      });
      this.loadData();
    },


    resetFilter() {
      this.filterContent.forEach((item, i) => {
        this.filterContent[i].selectedData = [];
        this.filterData[item.key] = item.selectedData.toString();
      });
      this.loadData();
    },


    orderData(item) {
      this.filterData = {
        ...this.filterData,
        ...item,
      };
      this.loadData();
    },
  },
};
</script>
